import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"checkmark\"><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#42B861\" /><path fill=\"#fff\" d=\"M6.913 11.728 3.718 8.532a.747.747 0 1 1 1.057-1.057L6.83 9.53l4.35-5.018a.749.749 0 1 1 1.133.983z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol